module.exports = __webpack_public_path__ + "assets/img/fish-attack.899874ac.png";